import {Api} from "@/repository/api";

export class SignatureRepository extends Api {
    constructor() {
        super("signatures");
    }
}